import React from "react";
import { Link } from "react-router-dom";
import Window from "../components/Window";
import { IconTile } from "../components/Icon";
import SlugAndWorm from "../components/SlugAndWorm";

// Who's behind PenPal Board, in the team's own words.
const sections: { title: string; body: React.ReactNode }[] = [
  {
    title: "Hi, it's us",
    body: (
      <>
        We're Slug and Worm, a trans and queer disabled couple who fell in love writing
        letters to each other, 13 years and counting. Slug's background is in
        Human Dimensions, the study of how people connect with each other and
        the world around them, and Worm's is in Engineering. We're a mixed-race family
        living in the Pacific Northwest. We're not a company: no investors, no
        ads, and nobody is selling your data.
      </>
    ),
  },
  {
    title: "Why we made this",
    body: (
      <>
        We wanted to create a space for the 2SLGBTQIA+ community: for those of
        us who prefer letter writing, who need a break from social media, and
        who connect best at a slower pace. Letters brought us together, and we
        hope they can do the same for you. No likes, no feeds, no read
        receipts. Just letters, and the people on the other end of them.
      </>
    ),
  },
  {
    title: "What we stand for",
    body: (
      <ul className="ml-5 list-disc">
        <li>Black Lives Matter. Black trans lives matter.</li>
        <li>Land back. Two-Spirit and Indigenous folks come first in our name for a reason.</li>
        <li>Disabled people belong everywhere, at whatever pace they need.</li>
        <li>No TERFs, no racism, no exceptions.</li>
        <li>
          We stand with Palestine, and with every people living through
          genocide and war, from Sudan to Congo and beyond. We're anti-war, and
          pro peace and love and letter writing.
        </li>
        <li>
          We're still learning. If we get something wrong, please tell us. We'd
          rather hear it than have you quietly leave.
        </li>
      </ul>
    ),
  },
  {
    title: "Just the two of us",
    body: (
      <>
        We both have full-time jobs and lives outside of this, so PenPal Board
        is a labor of love we tend in our spare time. We might not reply right
        away, but we read every report and every email, and we're so excited
        to see what this place grows into, with you.
      </>
    ),
  },
  {
    title: "Who keeps it safe",
    body: (
      <>
        <strong>Your letters are yours. We don't read them.</strong> The only
        time we ever look at a letter is when someone reports it to us. Every
        report is read by one of us, never a bot, and the person you report is
        never told who sent it. You can read how that works in{" "}
        <Link to="/guidelines">Safety &amp; Rules</Link>, and how we handle your
        data in our <Link to="/privacy">privacy page</Link>.
      </>
    ),
  },
  {
    title: "Say hi",
    body: (
      <>
        We love hearing from you: ideas, feedback, bugs, or just hello. Email
        us at <a href="mailto:2slgbtqiapenpal@gmail.com">2slgbtqiapenpal@gmail.com</a>.
        Want to help out? See <Link to="/get-involved">how to get involved</Link>.
        <span className="mt-2 block font-hand text-xl">happy writing ♥ -Slug &amp; Worm, the 2slgbtqiapenpal team</span>
      </>
    ),
  },
];

export default function WhoWeAre() {
  return (
    <Window title="who_we_are.txt" tone="pink" minimizable={false}>
      <h1 className="window-heading flex items-center gap-3">
        <IconTile name="heart" tone="pink" size={44} /> Who we are
      </h1>
      <div className="flex flex-wrap items-end justify-between gap-3">
        <p className="window-sub">The people behind PenPal Board, in our own words.</p>
        <SlugAndWorm scale={4} />
      </div>
      <div className="flex flex-col gap-4">
        {sections.map((s) => (
          <section key={s.title} className="profile-box bg-white">
            <div className="profile-box-body">
              <h2 className="font-display text-lg font-semibold">{s.title}</h2>
              <div className="text-sm">{s.body}</div>
            </div>
          </section>
        ))}
      </div>
    </Window>
  );
}
